import React, { ReactNode, useCallback } from 'react'
import { useHistory } from 'react-router-dom'

import { useSupplyChainPermissionsContext } from 'src/context/SupplyChainPermissionsContext'

interface PermissionRequiredProps {
  permissions?: string[]
  children: ReactNode
  redirect?: string
}
export const PermissionRequired = ({
  permissions: requiredPermissions,
  children,
  redirect,
}: PermissionRequiredProps) => {
  const { permissions } = useSupplyChainPermissionsContext()
  const history = useHistory()

  const hasPermission = useCallback(
    (requiredPermission: string): boolean => {
      const [scope, action] = requiredPermission.split('.')
      return !!permissions.find(
        (permission) =>
          permission.scope === scope && permission.action === action
      )
    },
    [permissions]
  )

  if (!requiredPermissions || requiredPermissions.length === 0)
    return <>{children}</>
  if (!permissions) return null

  if (permissions && !requiredPermissions.every(hasPermission)) {
    if (redirect) {
      history.push(redirect)
    } else {
      return null
    }
  }

  return <>{children}</>
}

